/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LabelFilter,
    LabelFilterFromJSON,
    LabelFilterFromJSONTyped,
    LabelFilterToJSON,
} from './';

/**
 * 
 * @export
 * @interface LockingConfig
 */
export interface LockingConfig {
    /**
     * 
     * @type {boolean}
     * @memberof LockingConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof LockingConfig
     */
    daysAfterClose?: number;
    /**
     * 
     * @type {string}
     * @memberof LockingConfig
     */
    message?: string;
    /**
     * 
     * @type {LabelFilter}
     * @memberof LockingConfig
     */
    labelFilter?: LabelFilter;
}

export function LockingConfigFromJSON(json: any): LockingConfig {
    return LockingConfigFromJSONTyped(json, false);
}

export function LockingConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): LockingConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'daysAfterClose': !exists(json, 'daysAfterClose') ? undefined : json['daysAfterClose'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'labelFilter': !exists(json, 'labelFilter') ? undefined : LabelFilterFromJSON(json['labelFilter']),
    };
}

export function LockingConfigToJSON(value?: LockingConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'daysAfterClose': value.daysAfterClose,
        'message': value.message,
        'labelFilter': LabelFilterToJSON(value.labelFilter),
    };
}

